module.exports = __webpack_public_path__ + "media/images/icon-map-8a833bf4fd7870225ec16e674d99a685.png";